import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LocalizedLink } from '../i18n/LocalizedLink';

const COOKIE_CONSENT_STORAGE_KEY = 'cookie_consent_v1';
type CookieConsentValue = 'accepted' | 'rejected';

const CookieConsentBanner: React.FC = () => {
  const { t } = useTranslation('common');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) as CookieConsentValue | null;
      if (saved !== 'accepted' && saved !== 'rejected') {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const persistConsent = (value: CookieConsentValue) => {
    try {
      localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, value);
    } finally {
      setVisible(false);
    }
  };

  if (!visible) return null;

  return (
    <aside className="cookie_consent_banner" role="dialog" aria-live="polite" aria-label={t('cookie.title')}>
      <div className="cookie_consent_text">
        <strong>{t('cookie.title')}</strong>
        <p>{t('cookie.body')}</p>
      </div>
      <div className="cookie_consent_actions">
        <LocalizedLink to="/cookie-policy" className="cookie_consent_link">
          {t('cookie.policy')}
        </LocalizedLink>
        <button
          type="button"
          className="cookie_consent_btn cookie_consent_btn_secondary"
          onClick={() => persistConsent('rejected')}
        >
          {t('cookie.reject')}
        </button>
        <button
          type="button"
          className="cookie_consent_btn cookie_consent_btn_primary"
          onClick={() => persistConsent('accepted')}
        >
          {t('cookie.accept')}
        </button>
      </div>
    </aside>
  );
};

export default CookieConsentBanner;
